<template>
    <div class="column is-12">
        <div class="column is-12">
            <div class="content mt-5">
                <h3>{{ $t("settings.campground.name_and_address") }}</h3>
            </div>

            <div class="columns">
                <div class="column col-6">
                    <div class="column is-12">
                        <label for="cg_name">{{ $t("settings.campground.cg_name") }}</label>
                        <form-input v-model="sp.value.cg_name" name="cg_name" />
                    </div>
                    <div class="column is-12">
                        <label for="cg_street1">{{ $t("settings.campground.cg_street1") }}</label>
                        <form-input v-model="sp.value.cg_street1" name="cg_street1" />
                    </div>
                    <div class="column is-12">
                        <label for="cg_street2">{{ $t("settings.campground.cg_street2") }}</label>
                        <form-input v-model="sp.value.cg_street2" name="cg_street2" />
                    </div>
                    <div class="column is-12">
                        <label for="cg_zipcode">{{ $t("settings.campground.cg_zipcode") }}</label>
                        <form-input v-model="sp.value.cg_zip_code" name="cg_zipcode" />
                    </div>
                    <div class="column is-12">
                        <label for="cg_city">{{ $t("settings.campground.cg_city") }}</label>
                        <form-input v-model="sp.value.cg_city" name="cg_city" />
                    </div>
                    <div class="column is-12">
                        <label for="cg_country">{{ $t("settings.campground.cg_country") }}</label>
                        <select
                            name="cg_country"
                            id="cg_country"
                            v-model="sp.value.cg_country"
                            class="input"
                        >
                            <option
                                v-for="(country, _) in sp.countries"
                                :value="country.key"
                                :key="country.key"
                            >
                                {{ country.name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="column col-6">
                    <div class="column is-12">
                        <label for="cg_phone">{{ $t("settings.campground.cg_phone") }}</label>
                        <form-input v-model="sp.value.cg_phone" name="cg_phone" />
                    </div>
                    <div class="column is-12">
                        <label for="cg_email">{{ $t("settings.campground.cg_mail") }}</label>
                        <form-input v-model="sp.value.cg_email" name="cg_email" />
                    </div>

                    <div class="content mt-5 ml-3">
                        <h3>{{ $t("settings.campground.gpsTitle") }}</h3>
                    </div>

                    <div class="column is-12">
                        <label for="cg_geo_lat">{{ $t("settings.campground.latitude") }}</label>
                        <form-input v-model="sp.value.cg_geo_lat" name="cg_geo_lat" />
                    </div>
                    <div class="column is-12">
                        <label for="cg_geo_lng">{{ $t("settings.campground.longitude") }}</label>
                        <form-input v-model="sp.value.cg_geo_lng" name="cg_geo_lng" />
                    </div>
                </div>
            </div>
        </div>

        <div class="column is-12">
            <div class="content">
                <h3>{{ $t("settings.campground.descriptionsTitle") }}</h3>
            </div>
            <label for="cg_description">{{ $t("settings.campground.long_text") }}</label>
            <wysiwyg v-model="sp.value.cg_description" name="cg_description" />
        </div>
        <div class="column is-12">
            <label for="cg_short_description">{{ $t("settings.campground.short_text") }}</label>
            <wysiwyg v-model="sp.value.cg_short_description" name="cg_short_description" />
        </div>

        <!-- I18N: Sprachen & Währung -->
        <div class="column is-12">
            <div class="content mt-5">
                <h3>{{ $t("settings.i18n.headline") }}</h3>
                <p v-html="$t('settings.i18n.copy')"></p>
            </div>
        </div>

        <div class="column is-12">
            <div class="columns">
                <div class="column is-5">
                    <label class="label edit-box__includes-inline-input">
                        {{ $t("settings.i18n.base_language") }}
                    </label>
                </div>
                <div class="column is-7">
                    <div>{{ languageLabel() }}</div>
                    <i
                        v-html="
                            $t('settings.i18n.base_language_info', {
                                SERVICE_EMAIL_LINK: sp.SERVICE_EMAIL_LINK
                            })
                        "
                    ></i>
                </div>
            </div>
        </div>

        <div class="column is-12">
            <div class="columns">
                <div class="column is-5">
                    <label class="label edit-box__includes-inline-input">
                        {{ $t("settings.i18n.languages") }}
                    </label>
                </div>
                <div class="column is-7">
                    <multiselect
                        v-model="sp.selectedLanguages"
                        :options="sp.languages"
                        :multiple="true"
                        track-by="code"
                        label="name"
                        :placeholder="$t('settings.i18n.pleaseSelect')"
                    />
                </div>
            </div>
        </div>

        <div class="column is-12">
            <div class="columns">
                <div class="column is-5">
                    <label for="currency" class="label edit-box__includes-inline-input">
                        {{ $t("settings.i18n.currency") }}
                    </label>
                </div>
                <div class="column is-7">
                    <span class="select">
                        <select
                            id="currency"
                            v-model="sp.selectedCurrency"
                            name="currency"
                            @change="onCurrencySelected()"
                        >
                            <option
                                v-for="(currency, _) in sp.currencies"
                                :value="currency.code"
                                :key="currency.code"
                            >
                                {{ currency.name }}
                            </option>
                        </select>
                    </span>
                </div>
            </div>
            <div class="column is-12" v-show="paymentChangeError" ref="paymentExist">
                <article class="currency-error message is-warning">
                    <div class="message-header">
                        <p>{{ $t("bookingDetails.refund.title") }}</p>
                    </div>
                    <div class="message-body">
                        Leider konnten wir die Währung nicht ändern. Eine Änderung der Währung ist
                        nur möglich wenn Ihr komplettes Guthaben ausgezahlt ist. Eine aktuelle
                        Übersicht finden sie unter:
                        <a :href="'/' + sp.lang + '/payments'" class="link">
                            {{ $t("generic.menu.payments") }}
                        </a>
                    </div>
                </article>
            </div>
        </div>

        <!-- Billing -->
        <div class="column is-12">
            <div class="content mt-5">
                <h3>{{ $t("settings.billing.headline") }}</h3>
                <p v-if="vatIdOptional">{{ $t("settings.billing.copyVatIdOptional") }}</p>
                <p v-else>{{ $t("settings.billing.copyVatIdNotOptional") }}</p>
            </div>
        </div>

        <div class="column is-12">
            <p>
                <textarea-autosize
                    class="input"
                    name="billing_address"
                    id="billing_address"
                    v-model="sp.value.billing_address"
                    :min-height="142"
                    :max-height="400"
                    :placeholder="$t('settings.billing.placeholder')"
                    :class="{ 'is-danger': sp.formErrors.billing_address }"
                />
                <span
                    class="help is-danger"
                    v-if="sp.formErrors.billing_address"
                    v-html="toList(sp.formErrors.billing_address)"
                ></span>
            </p>
        </div>

        <div class="column is-12">
            <div class="columns">
                <div class="column is-5">
                    <label for="company_name" class="label edit-box__includes-inline-input">{{
                        $t("settings.billing.companyName")
                    }}</label>
                </div>
                <div class="column is-7">
                    <form-input
                        id="company_name"
                        v-model="sp.value.company_name"
                        :error="sp.formErrors.company_name"
                    />
                </div>
            </div>
        </div>

        <div class="column is-12">
            <div class="columns">
                <div class="column is-5">
                    <label for="billing_email" class="label edit-box__includes-inline-input">{{
                        $t("settings.billing.email")
                    }}</label>
                </div>
                <div class="column is-7">
                    <form-input
                        id="billing_email"
                        v-model="sp.value.billing_email"
                        :error="sp.formErrors.billing_email"
                    />
                </div>
            </div>
        </div>

        <div class="column is-12" v-if="!vatIdOptional">
            <div class="columns">
                <div class="column is-4">
                    <label for="vat_id" class="label edit-box__includes-inline-input">
                        <span>{{ $t("settings.billing.vatId") }}</span>
                    </label>
                </div>
                <div class="column is-8">
                    <form-input
                        id="vat_id"
                        v-model="sp.value.vat_id"
                        :error="sp.formErrors.vat_id"
                    />
                </div>
            </div>
        </div>

        <div class="column is-12" v-if="vatIdOptional">
            <div class="column is-4">
                <label for="vat_id" class="label edit-box__includes-inline-input">
                    <span>{{ $t("settings.billing.vatIdOptional") }}</span>
                </label>
            </div>
            <div class="column is-8">
                <form-input id="vat_id" v-model="sp.value.vat_id" :error="sp.formErrors.vat_id" />
            </div>
        </div>
    </div>
</template>

<script>
import { FormInput, Wysiwyg } from '../../index';
import Multiselect from 'vue-multiselect';
import ArrayFilters from '../../../../filters/ArrayFilters';
import { AppModel } from '../../../../models';

export default {
    name: 'CampgroundTab',
    inject: ['settingsParent'],
    components: { FormInput, Wysiwyg, Multiselect },
    computed: {
        sp() {
            return this.settingsParent;
        },
        vatIdOptional() {
            const cgCountry =
                (this.sp.value && this.sp.value.cg_country) ||
                (AppModel && AppModel.country) ||
                'de';
            return String(cgCountry).toLowerCase() === 'de';
        },
        paymentChangeError() {
            const formErrors = this.sp.formErrors || {};
            const hasError = formErrors.currency && formErrors.currency[0] === 'payments exist';
            if(hasError) {
                this.$nextTick(() => {
                    // revert UI selection to persisted currency
                    this.sp.selectedCurrency =
                        this.sp.settingsBeforeChangesApply &&
                        this.sp.settingsBeforeChangesApply.currency;
                    // scroll warning into view (ref on this component)
                    this.$refs.paymentExist &&
                        this.$refs.paymentExist.scrollIntoView &&
                        this.$refs.paymentExist.scrollIntoView({ behavior: 'smooth' });
                });
            }
            return hasError;
        }
    },
    methods: {
        getLanguageObjectByCode(code) {
            let langObject = { code, name: code };
            (this.sp.value.languages || []).forEach(lang => {
                if(lang.code === code) {
                    langObject = lang;
                }
            });
            return langObject;
        },
        onCurrencySelected() {
            this.sp.showCurrencyModal = this.sp.selectedCurrency !== this.sp.value.currency;
        },
        toList(v) {
            return ArrayFilters.toList(v);
        },
        languageLabel() {
            // 1) zuerst in den verfügbaren Sprachen (haben meist `name`)
            const code = this.sp.value.base_language;
            const fromList = (this.sp.languages || []).find(l => l.code === code);
            if(fromList && (fromList.name || fromList.label)) { return fromList.name || fromList.label; }
            // 2) Fallback: zentrale Map im AppModel
            return (AppModel.systemLanguages && AppModel.systemLanguages[code]) || code || '';
        }
    },
    watch: {
        'sp.selectedLanguages'(newVal) {
            let hasBaseLanguage = false;
            (newVal || []).forEach(lang => {
                if(lang.code === this.sp.value.base_language) {
                    hasBaseLanguage = true;
                }
            });
            if(!hasBaseLanguage) {
                this.sp.selectedLanguages.unshift(
                    this.getLanguageObjectByCode(this.sp.value.base_language)
                );
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/campground-settings/tabs/CampgroundTab.vue